import 'slick-carousel';

export default {
    init() {
        this.slider = $('.gpi-slider');
        if (this.slider.length < 1) return;
        this.initSlider();
    },
    initSlider() {
        this.slider.slick({
            dots: false,
            infinite: true,
            speed: 400,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            prevArrow: $('.slick-arrow-prev'),
            nextArrow: $('.slick-arrow-next'),
        });
    },
};